
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/[[...setting]]",
      function () {
        return require("private-next-pages/account/[[...setting]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/[[...setting]]"])
      });
    }
  